import { cloneDeep } from 'lodash';

import { FUNNEL_STEPS_MIN } from '@src/emp-3.0/components/Funnel/Configurations';

import { hasAppId } from './check';

export const removeFunnelEmptyFilters = (payload) => {
  const copiedPayload = cloneDeep(payload);
  const { interval, funnel_events, filters } = copiedPayload;
  if (!interval) {
    return;
  }
  // remove empty filters
  copiedPayload.filters = copiedPayload.filters.filter(
    (item) => item.filter((x) => x.value.length).length,
  );

  if (funnel_events.filter((item) => item.event_name).length < FUNNEL_STEPS_MIN) {
    return;
  }
  // remove empty filters from funnel_events
  // @ts-ignore
  copiedPayload.funnel_events = copiedPayload.funnel_events
    .map((item) => {
      item.filters = item.filters.filter((x) => x.filter((y) => y.value.length).length);
      if (!item.event_name) {
        return null;
      }
      return item;
    })
    .filter(Boolean);

  if (copiedPayload.dimension_breakdowns) {
    // flatten breakdowns with values
    const breakdowns = copiedPayload.dimension_breakdowns
      .map((item) => {
        if (item.length === 0) return [];
        return [
          {
            field: item[0].field,
            op: item[0].op,
            value: item.map((x) => x.value).flat(),
          },
        ];
      })
      .filter((item) => item.length);

    // remove empty breakdowns
    copiedPayload.dimension_breakdowns = breakdowns.filter(
      (item) => item.filter((x) => x.value?.length).length,
    );
  }
  return copiedPayload;
};
